/**
 * `StringSearchFieldValues` renders a list of string values in light-blue-ish divs one
 * after the other in a vertical rectangle. Each string value is something chosen by
 * the user for a `StringSearchField`
 */

import React from 'react';

import StringSearchFieldValueTag from './StringSearchFieldValueTag';

require('styles/StringSearchField.styl');

class StringSearchFieldValues extends React.Component {
  /**
   * User clicks the "x" button at the right of a `StringSearchFieldValueTag`
   * @param  {string} value The string value to remove
   */
  onTouchTapValueTagRemoveButton(value) {
    this.props.onTouchTapValueTagRemoveButton(value);
  }

  render() {
    return (
      <div className="string-search-field-values">
        {(() => {
          if (this.props.values) {
            return this.props.values.map(value => {
              return (
                <StringSearchFieldValueTag
                  key={value}
                  value={value}
                  onTouchTapValueTagRemoveButton={this.onTouchTapValueTagRemoveButton.bind(this)}
                />
              );
            });
          }
        })()}
      </div>
    );
  }
}

export default StringSearchFieldValues;
